import { BaseEntity } from "yt-ng-framework";

export class InstrukcijaPlacanja extends BaseEntity{
    constructor(){
        super();
    }

    FirmaZrcID: number = null;
    Intermediary:string = null;
 

    Deserialize(input:any){
        this.ID=input.ID;
        this.FirmaZrcID = input.FirmaZrcID;
        this.Intermediary=input.Intermediary;    
        return this;
    }

    Serialize(input:InstrukcijaPlacanja){
        return input;
    }
}